import styled from "styled-components";
import { WithTheme } from "config/theme";

export const GrayFontContainer = styled.div`
  color: ${({ theme }: WithTheme) => theme.colors.gray.xdark};
`;
